import "./style.css";
import * as THREE from "three";
import { OrbitControls } from "three/examples/jsm/controls/OrbitControls.js";
import gsap from "gsap";
/**
 * Base
 */
// Canvas
const canvas = document.querySelector("canvas.webgl");

// Scene
const scene = new THREE.Scene();

/**
 * Object
 */

const image = new Image();
const texture = new THREE.Texture(image);

const imageLoaderManager = new THREE.LoadingManager();

const textureLoading = new THREE.TextureLoader(imageLoaderManager);
const imageTexture = textureLoading.load("./textures/world_512.jpg");

// texture.repeat.x = 2;
// texture.repeat.x = 2;
// texture.wrapS = true;
// texture.wrapT = true;
imageTexture.magFilter = THREE.NearestFilter;
//imageTexture.minFilter = THREE.NearestFilter;

const geometry = new THREE.SphereGeometry(1, 256, 256, 256);

const material = new THREE.MeshBasicMaterial({
	map: imageTexture,
	wireframe: true,
	color: "Lime",
	opacity: 0.4,
	transparent: true,
});
const mesh = new THREE.Mesh(geometry, material);

scene.add(mesh);

/**
 * Sizes
 */
const sizes = {
	width: window.innerWidth,
	height: window.innerHeight,
};

window.addEventListener("resize", () => {
	// Update sizes
	sizes.width = window.innerWidth;
	sizes.height = window.innerHeight;

	// Update camera
	camera.aspect = sizes.width / sizes.height;
	camera.updateProjectionMatrix();

	// Update renderer
	renderer.setSize(sizes.width, sizes.height);
	renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
});

/**
 * Camera
 */
// Base camera
const camera = new THREE.PerspectiveCamera(
	75,
	sizes.width / sizes.height,
	0.1,
	100
);

gsap.to(camera.position, { x: 1, duration: 0.5 });
gsap.to(camera.position, { z: -0.2, duration: 0.5 });
gsap.to(mesh.position, { y: 0, duration: 0.5 });
gsap.to(mesh.rotation, {
	y: Math.PI * 2,
	duration: 60,
	repeat: -1,
	ease: "linear",
});
scene.add(camera);

// Controls
const controls = new OrbitControls(camera, canvas);
controls.enableDamping = true;
controls.enabled = false;
//controls.enableZoom = false;

/**
 * Renderer
 */
const renderer = new THREE.WebGLRenderer({
	canvas: canvas,
	antialias: true,
});
renderer.setSize(sizes.width, sizes.height);
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));

/**
 * Animate
 */
const clock = new THREE.Clock();

const tick = () => {
	const elapsedTime = clock.getElapsedTime();

	// Update controls
	controls.update();

	// Render
	renderer.render(scene, camera);
	//console.log(camera.position.z);
	// Call tick again on the next frame
	window.requestAnimationFrame(tick);
};

tick();
/*
window.addEventListener("dblclick", () => {
	activatedFullScreen();
});
window.addEventListener("touchstart", () => {
	activatedFullScreen();
});
const activatedFullScreen = () => {
	const fullScreen =
		document.fullscreenElement || document.webkitFullscreenElement;

	if (!fullScreen) {
		if (canvas.requestFullscreen) {
			canvas.requestFullscreen();
		} else if (canvas.webkitRequestFullscreen) {
			canvas.webKitRequestFullscreen();
		}
	} else {
		document.exitFullscreen();
	}
};
*/
